import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=7ff2670a&scoped=true&"
import script from "./blacklist.vue?vue&type=script&lang=ts&"
export * from "./blacklist.vue?vue&type=script&lang=ts&"
import style0 from "./blacklist.vue?vue&type=style&index=0&id=7ff2670a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff2670a",
  null
  
)

export default component.exports